import React from "react";
import { useFormikContext } from "formik";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import mastercard from "../../../../../../../images/v2/master24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import amex from "../../../../../../../images/v2/amex24x24.svg";
import TextInput from "../../../../../components/form/text-input";
import styles from "./style.module.scss";

const IcPlus = () => {
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext();

  const hasWarning = (value) => {
    if (value > 1) {
      return "Please check pricing.";
    }
    return "";
  };


  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h6>Rate fees</h6>
          <div className={styles.accepts}>
            <img src={visa} />
            <img src={mastercard} />
            <img src={discover} />
          </div>
        </div>

        <div className={styles.body}>
          <TextInput
            label={"IC+ rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"ic_plus_rate"}
            name={"ic_plus_rate"}
            value={values.ic_plus_rate}
            onBlur={handleBlur}
            touched={touched?.ic_plus_rate}
            errored={errors?.ic_plus_rate}
            error={errors?.ic_plus_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "ic_plus_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Txn rate"}
            placeholder={"0.00"}
            prefix={"$"}
            type="text"
            id={"ic_plus_transaction_fee"}
            name={"ic_plus_transaction_fee"}
            value={values.ic_plus_transaction_fee}
            onBlur={handleBlur}
            touched={touched?.ic_plus_transaction_fee}
            errored={errors?.ic_plus_transaction_fee}
            error={errors?.ic_plus_transaction_fee}
            hasWarning={hasWarning(values?.ic_plus_transaction_fee)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "ic_plus_transaction_fee",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.header}>
          <h6>Rate fees amex</h6>
          <div className={styles.accepts}>
            <img src={amex} />
          </div>
        </div>

        <div className={styles.body}>
          <TextInput
            label={"IC+ rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"ic_plus_amex_rate"}
            name={"ic_plus_amex_rate"}
            value={values.ic_plus_amex_rate}
            onBlur={handleBlur}
            touched={touched?.ic_plus_amex_rate}
            errored={errors?.ic_plus_amex_rate}
            error={errors?.ic_plus_amex_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "ic_plus_amex_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Txn rate"}
            placeholder={"0.00"}
            prefix={"$"}
            type="text"
            id={"ic_plus_amex_transaction_fee"}
            name={"ic_plus_amex_transaction_fee"}
            value={values.ic_plus_amex_transaction_fee}
            onBlur={handleBlur}
            touched={touched?.ic_plus_amex_transaction_fee}
            errored={errors?.ic_plus_amex_transaction_fee}
            error={errors?.ic_plus_amex_transaction_fee}
            hasWarning={hasWarning(values?.ic_plus_amex_transaction_fee)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "ic_plus_amex_transaction_fee",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default IcPlus;
